// Mock data for Vaani Sargam Music World

export const schoolInfo = {
  name: "Vaani Sargam Music World",
  tagline: "Where every note finds its voice",
  location: "Oakville, Canada",
  description: "Discover the joy of Hindustani classical music with Vaani Sargam Music World. Build a strong foundation in swar and taal, explore bhajans and songs, and grow your confidence through performance. No experience needed—just a love for music. Join us in Oakville and start your musical journey today.",
  phone: "+1-647-678-8585",
  email: "vaani.sargam.mw@gmail.com",
  address: "91 Mccraney street west oakville, L6H 1H5",
  logo: "https://customer-assets.emergentagent.com/job_sur-sangeet/artifacts/pe1oh3xk_d1e031134159438ea6496b0e93355ea8.webp",
  socialMedia: {
    youtube: "https://www.youtube.com/@VaaniSargamMW",
    instagram: "https://www.instagram.com/vaani.sargam/"
  }
};

export const heroImages = [
  "https://customer-assets.emergentagent.com/job_sur-sangeet/artifacts/g67sea5j_DSC_8623.jpg",
  "https://customer-assets.emergentagent.com/job_sur-sangeet/artifacts/7dqggksw_DSC_8607.jpg",
  "https://customer-assets.emergentagent.com/job_sur-sangeet/artifacts/9okt2kga_annual%20day%202025.png"
];

export const aboutContent = {
  title: "Our Story",
  story: "Founded with a deep passion for preserving and sharing the rich heritage of Hindustani classical music, Vaani Sargam Music World began as a dream to create a bridge between traditional Indian music and the multicultural community of Oakville. Our founder, inspired by the timeless beauty of ragas and the joy of musical expression, established this school to nurture musical talent in both children and adults.",
  mission: "To provide authentic, high-quality Hindi music education while fostering a deep appreciation for Indian classical music traditions.",
  achievements: [
    "Annual cultural performances and concerts",
    "Certified instructors in Hindustani classical music", 
    "Community recognition for promoting Indian culture",
    "Formal training from Prayag Sangeet Samiti"
  ],
  teachingImage: "https://customer-assets.emergentagent.com/job_sur-sangeet/artifacts/7dqggksw_DSC_8607.jpg"
};

export const classes = [
  {
    id: 1,
    name: "Adult Hindustani Classical Music",
    description: "Build strong musical foundation with swars & ragas. Learn bhajans, Bollywood melodies & cultural shloks. Perform on stage and shine with confidence. No prior experience needed – just bring your love for music!",
    ageGroup: "Adults (18+)",
    duration: "60 minutes",
    level: "Beginner to Advanced",
    highlights: ["Swars & ragas foundation", "Bhajans & cultural shloks", "Bollywood melodies", "Stage performance", "Breathing techniques", "Cultural connection"]
  },
  {
    id: 2,
    name: "Kids Music Program",
    description: "Make learning Hindustani Classical Music fun, joyful, and meaningful for kids! Build confidence, focus, and cultural connection through music. Sing, express, and grow — one note at a time!",
    ageGroup: "Kids (5-17 years)",
    duration: "45 minutes", 
    level: "Beginner to Intermediate",
    highlights: ["Fun musical foundation", "Swars & simple ragas", "Cultural songs & bhajans", "Confidence building", "Stage performance", "Joyful learning"]
  }
];

export const teachers = [
  {
    id: 1,
    name: "Snehlata Pramanik",
    title: "Founder & Principal Instructor", 
    qualifications: "Senior Diplomas in Hindustani Classical Vocal Music and Bhav Sangeet from Prayag Sangeet Samiti",
    specialization: "Hindustani Classical Vocals, Bhav Sangeet, Ragas, Bhajans",
    description: "Hello and welcome! I'm Snehlata Pramanik, the Founder and Teacher at Vaani Sargam Music World, based in Canada. Music has always been my greatest passion and source of joy. I founded Vaani Sargam Music World with the vision of bringing the beauty of Indian classical music to learners of all ages — helping them connect with their cultural roots, discover their voice, and express themselves through melody and rhythm. With years of training in Hindustani Classical Vocal Music and Bhav Sangeet from Prayag Sangeet Samiti, I have completed several levels of formal certification, including Senior Diplomas. Since 2021, I've been dedicated to teaching raags, shlokas, bhajans, and Hindi music to children and adults, creating a nurturing and joyful environment where music becomes a form of meditation and self-expression. Through Vaani Sargam Music World, my goal is to share not just the technical aspects of music, but also the emotion, discipline, and cultural richness that make it timeless. Our classes are rooted in tradition yet designed to be engaging, interactive, and fun — especially for young learners growing up in Canada. Music is more than sound — it's a journey. And I'm honored to guide each student on theirs.",
    image: "https://customer-assets.emergentagent.com/job_sur-sangeet/artifacts/2c6ank8d_DSC_8885%20%281%29.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Shivali Kapila",
    role: "Parent",
    content: "Sneh is great Indian classical music teacher. She knows how to keep young kids interested throughout the one hour class. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Ankita Sharma",
    role: "Parent",
    content: "This is the place where kids get introduced to the world of music and learn about Indian classical musical heritage. Helping them enhancing their creativity and keeping them engaged positively.",
    rating: 5
  },
  {
    id: 3,
    name: "Sumeet Sharma",
    role: "Parent",
    content: "Great experience! Especially if you want your kids to learn bhajans & devotional music.",
    rating: 5
  },
  {
    id: 4,
    name: "Shikha Mehta",
    role: "Local Guide",
    content: "Great music teacher with lots of knowledge. Highly recommend",
    rating: 5
  },
  {
    id: 5,
    name: "Dr. Mehak Bharti",
    role: "Parent",
    content: "Great experience",
    rating: 5
  },
  {
    id: 6,
    name: "Amar Pathak",
    role: "Student",
    content: "Sneh is amazing teacher ❤️",
    rating: 5
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Spring Concert 2024",
    date: "2024-04-15",
    time: "6:00 PM",
    venue: "Oakville Community Centre",
    description: "Annual showcase featuring performances by students of all levels.",
    type: "concert"
  },
  {
    id: 2,
    title: "Holi Celebration",
    date: "2024-03-25",
    time: "2:00 PM", 
    venue: "School Studio",
    description: "Celebrate the festival of colors with music, dance, and cultural activities.",
    type: "cultural"
  }
];